import * as React from "react";
import { Component } from "react";
import { Col, ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import DividerLine from "src/components/common/DividerLine";
import LoadingStatus from "src/components/common/LoadingStatus";
import { TIMEOUT } from "src/global";
import { IBaseState } from "src/interfaces";
import { IElectricityFromGridProps } from "./interfaces";

export default class ElectricityFromGrid extends Component<IElectricityFromGridProps, IBaseState> {
  public constructor(props: IElectricityFromGridProps) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  public componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, TIMEOUT);
  }

  public render() {
    if (this.state.loading) {
      return (
        <fieldset className="fieldset-left">
          <legend>Electricity from Grid</legend>
          <LoadingStatus width={25} height={25} singular={true} type="Watch" />
        </fieldset>
      );
    }

    let readOnly: boolean = this.props.match.params.priorId === undefined ? false : true;
    if (this.props.priorDataEditable) {
      readOnly = false;
    }

    const totalElectricityFromGrid = this.props.gridReading - this.props.priorGridReading;
    const onPeakElectricityFromGrid =
      this.props.onPeakGridReading - this.props.priorOnPeakGridReading;
    const offPeakFromGrid = totalElectricityFromGrid - onPeakElectricityFromGrid;

    const xsLabelWidthL = 6;
    const xsInputWidthL = 6;
    const smLabelWidthL = 6;
    const smInputWidthL = 6;
    const mdLabelWidthL = 6;
    const mdInputWidthL = 6;

    return (
      <fieldset className="fieldset-left">
        <legend>Amount of Electricity from Grid</legend>
        <FormGroup bsSize="small" controlId="gridReadDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Read Date
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.gridReadDate).toISOString().substring(0, 10)}
              onChange={this.props.gridReadDateChanged}
              readOnly={readOnly}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="gridReading">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Reading
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.gridReading}
              onChange={this.props.gridReadingChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="priorGridReadDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Last Read
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.priorGridReadDate).toISOString().substring(0, 10)}
              readOnly={readOnly}
              tabIndex={-1}
              onChange={this.props.priorGridReadDateChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="priorGridReading">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Reading
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.priorGridReading}
              readOnly={readOnly}
              tabIndex={readOnly ? -1 : undefined}
              onChange={this.props.priorGridReadingChanged}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthL}
          smOffset={smLabelWidthL}
          mdOffset={mdLabelWidthL}
          xs={xsInputWidthL}
          sm={smInputWidthL}
          md={mdInputWidthL}
        />
        <FormGroup bsSize="small" controlId="totalElectricityFromGrid">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Total from Grid
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={totalElectricityFromGrid}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <legend>On-peak Electricity</legend>
        <FormGroup bsSize="small" controlId="onPeakGridReadDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Read Date
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.onPeakGridReadDate).toISOString().substring(0, 10)}
              onChange={this.props.onPeakGridReadDateChanged}
              readOnly={readOnly}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="onPeakGridReading">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Reading
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.onPeakGridReading}
              onChange={this.props.onPeakGridReadingChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="priorOnPeakGridReadDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Last Read
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.priorOnPeakGridReadDate).toISOString().substring(0, 10)}
              readOnly={readOnly}
              tabIndex={-1}
              onChange={this.props.priorOnPeakGridReadDateChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="priorOnPeakGridReading">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Reading
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.priorOnPeakGridReading}
              readOnly={readOnly}
              tabIndex={readOnly ? -1 : undefined}
              onChange={this.props.priorOnPeakGridReadingChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="onPeakTotalFromGrid">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            On-peak Grid
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={onPeakElectricityFromGrid}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthL}
          smOffset={smLabelWidthL}
          mdOffset={mdLabelWidthL}
          xs={xsInputWidthL}
          sm={smInputWidthL}
          md={mdInputWidthL}
        />
        <FormGroup bsSize="small" controlId="offPeakFromGrid">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Off-peak Grid
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={offPeakFromGrid}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
      </fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/dualrate/ElectricityFromGrid.tsx